import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';

const J = {
    bg: '#0d0d1a',
    surface: '#0d1f33',
    border: '0.5px solid #294766',
    text: '#b0c8e0',
    muted: '#a3d1ff',
    accent: '#66b2ff',
};

/**
 * UpdateAvailableDialog — shown when a new deployment is detected via siteConfig version change.
 */
export default function UpdateAvailableDialog({ open, onDismiss }) {
    const handleRefresh = () => {
        window.location.reload();
    };

    const handleLater = () => {
        onDismiss();
    };

    return (
        <Dialog
            open={open}
            PaperProps={{
                sx: {
                    bgcolor: J.surface,
                    border: J.border,
                    borderRadius: 2,
                    minWidth: 320,
                },
            }}
        >
            <DialogContent>
                <Box id="update-dialog-inner" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, py: 1 }}>
                    <SystemUpdateAltIcon sx={{ color: J.accent, fontSize: 40 }} />
                    <Typography variant="h6" sx={{ color: J.accent, fontWeight: 600, textAlign: 'center' }}>
                        Update available
                    </Typography>
                    <Typography variant="body2" sx={{ color: J.muted, textAlign: 'center', lineHeight: 1.6 }}>
                        Jerny has been updated. Please refresh to get the latest version.
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
                <Button
                    variant="outlined"
                    onClick={handleRefresh}
                    sx={{
                        color: J.accent,
                        borderColor: J.accent,
                        '&:hover': { bgcolor: '#0d1f33', borderColor: J.accent },
                    }}
                >
                    Refresh
                </Button>

                <Button
                    variant="outlined"
                    onClick={handleLater}
                    sx={{
                        color: J.accent,
                        borderColor: J.accent,
                        '&:hover': { bgcolor: '#0d1f33', borderColor: J.accent },
                    }}
                >
                    Later
                </Button>
            </DialogActions>
        </Dialog>
    );
}
